import React, {useContext, useDebugValue, useEffect} from 'react';
import {Nav, Tab} from 'react-bootstrap';
import RegisterContext from '../../RegisterContext';
import './style.scss'

export default function StepsIndicator({steps,step, labels, push, previous}) {

  const {user} = useContext(RegisterContext)

  useEffect(() => {
    if (steps.length && user?.register?.completedStep) {
      push(steps[user?.register?.completedStep].id)
    }
  }, [user, steps])

    return (
        <div className="stepsIndicator">
          <div onClick={previous}>back</div>
          <Tab.Container>
            <Nav
              variant="tabs"
              as="ul"
              onSelect={(selectedKey) => alert(`selected ${selectedKey}`)}
            >
              {steps.map((stepEl, index) => (
                <Nav.Item as="li" key={index} className={`${stepEl.id === step.id ? 'active' :''}`}>
                  <Nav.Link>
                    <span className="round-tab">{index + 1}</span>
                    <span className="label-tab">{labels[stepEl.id]}פרטים אישיים</span>
                  </Nav.Link>
                </Nav.Item>              
              ))}
            </Nav>
          </Tab.Container>
        </div>
    )
}